// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router/index'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueCookie from 'vue-cookie'
// import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import config from './config'

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueCookie);

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  //设置菜单隐藏
  // router.options.routes[1].hidden = true;
  if (to.path == '/login') {
    VueCookie.delete('token');
  }
  let token = VueCookie.get('token');
  if (!token && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next()
  }
});

//请求拦截
axios.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  if(VueCookie.get('token')) {
    config.headers["Authorization"] = VueCookie.get('token');
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

setInterval(function() {
  if(!VueCookie.get("qiniu_token")){
    axios.post(config.api_url + '/qiniu'
    ).then(response => {
        VueCookie.set("qiniu_token", response.data, { expires: '55m' })
    }).catch(error => {
        console.log(error);
    });
  }
}, 1000)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});





// WEBPACK FOOTER //
// ./src/main.js